import { SelectFormField } from '@/components/UberForm'
import CheckboxFormField from '@/components/UberForm/Helpers/CheckBoxFormField'
import { MassExportConfigDto } from '@/endpoints/models/base'
import { useStructureStatus } from '@/pages/User/pages/Home/utils'
import { DdlModalType } from '@/types'

import { DateTimeOptions } from './DateTimeOptions'
import { ExportConfigFieldsProps } from './types'

export const ExportConfigFields = ({
	isSqlGen = false,
	enableExportStrategy,
	generateFromLastTemplate,
	generateFromLastVersion,
	massExportSorting,
	massExportSortingOptions,
	massExportStrategies,
	massExportStrategy,
	setGenerateFromLastTemplate,
	setGenerateFromLastVersion,
	setIgnoreErrors,
	setMassExportSorting,
	setMassExportStrategy,
	setStructureStatus,
	setTemplateDate,
	setVersionDate,
	t,
	templateDate,
	type,
	versionDate,
}: ExportConfigFieldsProps) => {
	const nodeStates = useStructureStatus(t)

	return (
		<>
			{type === DdlModalType.CreateGit ? (
				<></>
			) : (
				<>
					<SelectFormField
						name="massExportStatus"
						title={t('MASS_DOWNLOAD_STATUS')}
						options={nodeStates}
						valueKey="value"
						labelKey="label"
						allowEmpty
						onChange={(value) => {
							setStructureStatus(value)
						}}
						isMulti
					/>
					{(enableExportStrategy || type === DdlModalType.PushToGit) && (
						<SelectFormField
							name="massExportStrategy"
							formless
							title={t('MASS_DOWNLOAD_STRATEGY')}
							options={massExportStrategies || []}
							valueKey="value"
							labelKey="label"
							onChange={(val) =>
								setMassExportStrategy(
									val as MassExportConfigDto.MassExportStrategyEnum,
								)
							}
							initialValue={massExportStrategy}
						/>
					)}
					<SelectFormField
						name="massExportSorting"
						formless
						title={t('MASS_DOWNLOAD_SORTING')}
						options={massExportSortingOptions || []}
						valueKey="value"
						labelKey="label"
						onChange={(val) => setMassExportSorting(val)}
						initialValue={massExportSorting}
					/>
					<CheckboxFormField
						name="ignoreErrors"
						title={t('IGNORE_ERRORS')}
						onChange={(val) => setIgnoreErrors(val)}
					/>
					{isSqlGen && (
						<DateTimeOptions
							generateFromLastTemplate={generateFromLastTemplate}
							generateFromLastVersion={generateFromLastVersion}
							setGenerateFromLastTemplate={setGenerateFromLastTemplate}
							setGenerateFromLastVersion={setGenerateFromLastVersion}
							setTemplateDate={setTemplateDate}
							setVersionDate={setVersionDate}
							t={t}
							templateDate={templateDate}
							versionDate={versionDate}
						/>
					)}
				</>
			)}
		</>
	)
}
